const translations = {
  en: {
    'common.search': 'Search',
    'common.logout': 'Logout',
    'common.settings': 'Settings',
    'common.notifications': 'Notifications',
    'common.profile': 'Profile',
    'common.save': 'Save',
    'common.cancel': 'Cancel',
    'common.delete': 'Delete',
    'common.edit': 'Edit',
    'common.view': 'View',
    'common.loading': 'Loading...',
    'common.error': 'Error',
    'common.success': 'Success',
    'common.add': 'Add',
    'common.create': 'Create',
    'common.update': 'Update',
    'common.submit': 'Submit',
    'common.close': 'Close',
    'common.yes': 'Yes',
    'common.no': 'No',
    'common.all': 'All',
    'common.filter': 'Filter',
    'common.export': 'Export',
    'common.print': 'Print',
    'common.download': 'Download',
    'common.actions': 'Actions',
    'common.status': 'Status',
    'common.date': 'Date',
    'common.amount': 'Amount',
    'common.name': 'Name',
    'common.email': 'Email',
    'common.phone': 'Phone',
    'common.address': 'Address',
    'common.description': 'Description',
    'common.type': 'Type',
    'common.category': 'Category',
    'common.noData': 'No data found',
    'common.select': 'Select',
    'common.required': 'Required',
    'common.optional': 'Optional',
    'nav.dashboard': 'Dashboard',
    'nav.overview': 'Overview',
    'nav.properties': 'Properties',
    'nav.tenants': 'Tenants',
    'nav.payments': 'Payments',
    'nav.collections': 'Collections',
    'nav.landlordPayments': 'Owner Payments',
    'nav.tenantPayments': 'Rent Payments',
    'nav.reports': 'Reports',
    'nav.expenses': 'Expenses',
    'nav.history': 'History',
    'nav.cashier': 'Cashier',
    'nav.advertisements': 'Ads',
    'nav.messages': 'Messages',
    'nav.chat': 'Messages',
    'nav.messaging': 'Messages',
    'nav.propertyAsset': 'Properties',
    'nav.paymentsCashFlow': 'Payments',
    'nav.rentsTracking': 'Rents',
    'nav.worksClaims': 'Works',
    'nav.documents': 'Documents',
    'nav.businessTracking': 'Activity',
    'nav.listings': 'Listings',
    'nav.visits': 'Visits',
    'nav.requests': 'Requests',
    'nav.inbox': 'Inbox',
    'nav.utilities': 'CIE / SODECI',
    'nav.debtCollection': 'Debt Collection',
    'nav.reminders': 'Reminders',
    'nav.leases': 'Leases',
    'nav.automation': 'Automation',
    'nav.management': 'Management',
    'nav.users': 'Users',
    'nav.owners': 'Owners',
    'nav.accounting': 'Accounting',
    'nav.analytics': 'Analytics',
    'nav.subscription': 'Subscription',
    'nav.transactions': 'History',
    'nav.clientList': 'Clients',
    'nav.profileSettings': 'Profile',
    'profile.title': 'Profile',
    'profile.personal': 'Personal Info',
    'profile.password': 'Password',
    'profile.notifications': 'Notification Preferences',
    'profile.language': 'Language',
    'profile.photo': 'Profile Photo',
    'notifications.title': 'Notifications',
    'notifications.noNotifications': 'No notifications',
    'notifications.markAllRead': 'Mark all as read',
    'notifications.preferences': 'Notification Preferences',
    'notifications.email': 'Email Notifications',
    'notifications.inApp': 'In-App Notifications',
    'notifications.documentApproval': 'Document Approval',
    'notifications.paymentReminders': 'Payment Reminders',
    'notifications.contractDeadlines': 'Contract Deadlines',
    'notifications.statusChanges': 'Status Changes',
    'language.select': 'Select Language',
    'language.english': 'English',
    'language.french': 'French',
    'dashboard.total': 'Total',
    'dashboard.monthly': 'Monthly',
    'dashboard.yearly': 'Yearly',
    'dashboard.thisMonth': 'This Month',
    'dashboard.lastMonth': 'Last Month',
    'dashboard.thisYear': 'This Year',
    'dashboard.pending': 'Pending',
    'dashboard.approved': 'Approved',
    'dashboard.rejected': 'Rejected',
    'dashboard.active': 'Active',
    'dashboard.inactive': 'Inactive',
    'dashboard.vacant': 'Vacant',
    'dashboard.occupied': 'Occupied',
    'dashboard.upToDate': 'Up to Date',
    'dashboard.overdue': 'Overdue',
    'dashboard.paid': 'Paid',
    'dashboard.unpaid': 'Unpaid',
    'accounting.recordPayment': 'Record Payment',
    'accounting.recordCashPayment': 'Record Cash Payment',
    'accounting.recordLandlordPayment': 'Record Landlord Payment',
    'accounting.addExpense': 'Add Expense',
    'accounting.editExpense': 'Edit Expense',
    'accounting.viewExpense': 'View Expense',
    'accounting.printExpense': 'Print Expense',
    'accounting.totalRevenue': 'Total Revenue',
    'accounting.totalExpenses': 'Total Expenses',
    'accounting.netIncome': 'Net Income',
    'accounting.cashBalance': 'Cash Balance',
    'accounting.pendingPayments': 'Pending Payments',
    'accounting.commission': 'Commission',
    'accounting.netAmount': 'Net Amount',
    'accounting.paymentMethod': 'Payment Method',
    'accounting.building': 'Building',
    'accounting.property': 'Property',
    'accounting.tenant': 'Tenant',
    'accounting.landlord': 'Landlord',
    'accounting.selectTenant': 'Select Tenant',
    'accounting.selectLandlord': 'Select Landlord',
    'accounting.selectProperty': 'Select Property',
    'accounting.selectAccount': 'Select Account',
    'accounting.paymentDate': 'Payment Date',
    'accounting.rentPeriod': 'Rent Period',
    'accounting.expenseDate': 'Expense Date',
    'accounting.expenseCategory': 'Expense Category',
    'accounting.expenseAmount': 'Expense Amount',
    'accounting.expenseDescription': 'Expense Description',
    'accounting.receiptNumber': 'Receipt Number',
    'accounting.invoiceNumber': 'Invoice Number',
    'accounting.recording': 'Recording...',
    'accounting.adding': 'Adding...',
    'accounting.noCashierAccounts': 'No cashier accounts found. Click "Add Account" to create one.',
    'accounting.cashierAccountCreated': 'Cashier account created successfully!',
    'accounting.collections': 'Collections',
    'accounting.expenses': 'Expenses',
    'accounting.collectionsByPeriod': 'Collections by Period',
    'accounting.cancel': 'Cancel',
    'accounting.addAccount': 'Add Account',
    'accounting.canceledPaymentsHistory': 'Canceled Payments History',
    'accounting.amountCanceled': 'Amount Canceled',
    'accounting.paymentsByBuilding': 'Payments by Building',
    'accounting.paymentsByTenant': 'Payments by Tenant',
    'accounting.expensesByPeriod': 'Expenses by Period',
    'accounting.buildingPerformance': 'Building Performance',
    'accounting.paymentStatusBreakdown': 'Payment Status Breakdown',
    'accounting.paymentsByPeriod': 'Payments by Period',
    'accounting.commissionsByPeriod': 'Commissions by Period',
    'accounting.refundsReport': 'Refunds Report',
    'accounting.financialManagement': 'Financial Management',
    'accounting.quickActions': 'Quick Actions',
    'accounting.viewAllTenants': 'View all tenants and their payment status',
    'accounting.recordSecurityDepositPayment': 'Record Security Deposit Payment',
    'accounting.processSecurityDepositRefund': 'Process Security Deposit Refund',
    'accounting.addTransaction': 'Add Transaction',
    'accounting.recentTransactions': 'Recent Transactions',
    'accounting.addCashierAccount': 'Add Cashier Account',
    'accounting.recordNewPayment': 'Record New Payment',
    'accounting.confirmPaymentApproval': 'Confirm Payment Approval',
    'accounting.editExpense': 'Edit Expense',
    'landlord.myProperties': 'My Properties',
    'landlord.myTenants': 'My Tenants',
    'landlord.rentCollected': 'Rent Collected',
    'landlord.netPayout': 'Net Payout',
    'landlord.paymentHistory': 'Payment History',
    'landlord.netPayments': 'Net Payments',
    'tenant.myRent': 'My Rent',
    'tenant.paymentHistory': 'Payment History',
    'tenant.makePayment': 'Make Payment',
    'tenant.nextPayment': 'Next Payment',
    'tenant.leaseAgreement': 'Lease Agreement',
    'tenant.documents': 'Documents',
    'sales.listings': 'Listings',
    'sales.addListing': 'Add Listing',
    'sales.editListing': 'Edit Listing',
    'sales.scheduleVisit': 'Schedule Visit',
    'sales.visitStatus': 'Visit Status',
    'sales.clientRequests': 'Client Requests',
    'technician.workOrders': 'Work Orders',
    'technician.inspections': 'Inspections',
    'technician.maintenance': 'Maintenance',
    'technician.createWorkOrder': 'Create Work Order',
    'technician.createInspection': 'Create Inspection',
    'admin.clientsPending': 'Clients Pending Approval',
    'admin.documentVerification': 'Document Verification',
    'admin.debtCollection': 'Debt Collection',
    'admin.automation': 'Automation & Reports',
    'director.overview': 'Overview',
    'director.management': 'Management',
    'director.users': 'Users',
    'director.properties': 'Properties',
    'director.analytics': 'Analytics',
    'director.subscription': 'Subscription',
    'actions.add': 'Add',
    'actions.edit': 'Edit',
    'actions.delete': 'Delete',
    'actions.view': 'View',
    'actions.save': 'Save',
    'actions.cancel': 'Cancel',
    'actions.submit': 'Submit',
    'actions.approve': 'Approve',
    'actions.reject': 'Reject',
    'actions.print': 'Print',
    'actions.export': 'Export',
    'actions.download': 'Download',
    'actions.upload': 'Upload',
    'actions.search': 'Search',
    'actions.filter': 'Filter',
    'actions.reset': 'Reset',
    'actions.clear': 'Clear',
    'actions.close': 'Close',
    'actions.back': 'Back',
    'actions.next': 'Next',
    'actions.previous': 'Previous',
    'actions.send': 'Send',
    'actions.reply': 'Reply',
    'actions.markAsRead': 'Mark as Read',
    'actions.markAllRead': 'Mark All as Read',
    'status.pending': 'Pending',
    'status.approved': 'Approved',
    'status.rejected': 'Rejected',
    'status.active': 'Active',
    'status.inactive': 'Inactive',
    'status.vacant': 'Vacant',
    'status.occupied': 'Occupied',
    'status.paid': 'Paid',
    'status.unpaid': 'Unpaid',
    'status.overdue': 'Overdue',
    'status.completed': 'Completed',
    'status.inProgress': 'In Progress',
    'status.cancelled': 'Cancelled',
    'messages.sendMessage': 'Send Message',
    'messages.typeMessage': 'Type a message...',
    'messages.noMessages': 'No messages',
    'messages.noConversations': 'No conversations',
    'messages.selectUser': 'Select a user to start chatting',
    'reports.generate': 'Generate Report',
    'reports.download': 'Download Report',
    'reports.export': 'Export Report',
    'reports.selectType': 'Select Report Type',
    'reports.selectPeriod': 'Select Period',
    'reports.startDate': 'Start Date',
    'reports.endDate': 'End Date',
    'modal.confirm': 'Confirm',
    'modal.cancel': 'Cancel',
    'modal.deleteConfirm': 'Are you sure you want to delete this item?',
    'modal.unsavedChanges': 'You have unsaved changes. Are you sure you want to leave?',
    'error.required': 'This field is required',
    'error.invalidEmail': 'Invalid email address',
    'error.invalidPhone': 'Invalid phone number',
    'error.invalidAmount': 'Invalid amount',
    'error.uploadFailed': 'Upload failed',
    'error.loadFailed': 'Failed to load data',
    'error.saveFailed': 'Failed to save',
    'error.deleteFailed': 'Failed to delete',
    'error.networkError': 'Network error. Please try again.',
    'error.unauthorized': 'Unauthorized access',
    'error.notFound': 'Not found',
    'error.serverError': 'Server error. Please try again later.',
    'success.saved': 'Saved successfully',
    'success.deleted': 'Deleted successfully',
    'success.uploaded': 'Uploaded successfully',
    'success.sent': 'Sent successfully',
    'success.updated': 'Updated successfully',
    'success.created': 'Created successfully'
  },
  fr: {
    'common.search': 'Rechercher',
    'common.logout': 'Déconnexion',
    'common.settings': 'Paramètres',
    'common.notifications': 'Notifications',
    'common.profile': 'Profil',
    'common.save': 'Enregistrer',
    'common.cancel': 'Annuler',
    'common.delete': 'Supprimer',
    'common.edit': 'Modifier',
    'common.view': 'Voir',
    'common.loading': 'Chargement...',
    'common.error': 'Erreur',
    'common.success': 'Succès',
    'common.add': 'Ajouter',
    'common.create': 'Créer',
    'common.update': 'Mettre à jour',
    'common.submit': 'Soumettre',
    'common.close': 'Fermer',
    'common.yes': 'Oui',
    'common.no': 'Non',
    'common.all': 'Tous',
    'common.filter': 'Filtrer',
    'common.export': 'Exporter',
    'common.print': 'Imprimer',
    'common.download': 'Télécharger',
    'common.actions': 'Actions',
    'common.status': 'Statut',
    'common.date': 'Date',
    'common.amount': 'Montant',
    'common.name': 'Nom',
    'common.email': 'Email',
    'common.phone': 'Téléphone',
    'common.address': 'Adresse',
    'common.description': 'Description',
    'common.type': 'Type',
    'common.category': 'Catégorie',
    'common.noData': 'Aucune donnée trouvée',
    'common.select': 'Sélectionner',
    'common.required': 'Requis',
    'common.optional': 'Optionnel',
    'nav.dashboard': 'Tableau de bord',
    'nav.overview': 'Vue d’ensemble',
    'nav.properties': 'Biens',
    'nav.tenants': 'Locataires',
    'nav.payments': 'Paiements',
    'nav.collections': 'Encaissements',
    'nav.landlordPayments': 'Reversements',
    'nav.tenantPayments': 'Loyers',
    'nav.reports': 'Rapports',
    'nav.expenses': 'Dépenses',
    'nav.history': 'Historique',
    'nav.cashier': 'Caisse',
    'nav.advertisements': 'Annonces',
    'nav.messages': 'Messages',
    'nav.chat': 'Messages',
    'nav.messaging': 'Messages',
    'nav.propertyAsset': 'Biens',
    'nav.paymentsCashFlow': 'Paiements',
    'nav.rentsTracking': 'Loyers',
    'nav.worksClaims': 'Travaux',
    'nav.documents': 'Documents',
    'nav.businessTracking': 'Activité',
    'nav.listings': 'Annonces',
    'nav.visits': 'Visites',
    'nav.requests': 'Demandes',
    'nav.inbox': 'Boîte de réception',
    'nav.utilities': 'CIE / SODECI',
    'nav.debtCollection': 'Recouvrement',
    'nav.reminders': 'Rappels',
    'nav.leases': 'Baux',
    'nav.automation': 'Automatisation',
    'nav.management': 'Gestion',
    'nav.users': 'Utilisateurs',
    'nav.owners': 'Propriétaires',
    'nav.accounting': 'Comptabilité',
    'nav.analytics': 'Analyses',
    'nav.subscription': 'Abonnement',
    'nav.transactions': 'Historique',
    'nav.clientList': 'Clients',
    'nav.profileSettings': 'Profil',
    'profile.title': 'Profil',
    'profile.personal': 'Infos personnelles',
    'profile.password': 'Mot de passe',
    'profile.notifications': 'Notifications',
    'profile.language': 'Langue',
    'profile.photo': 'Photo de profil',
    'notifications.title': 'Notifications',
    'notifications.noNotifications': 'Aucune notification',
    'notifications.markAllRead': 'Tout marquer comme lu',
    'notifications.preferences': 'Préférences',
    'notifications.email': 'Emails',
    'notifications.inApp': 'Dans l\'app',
    'notifications.documentApproval': 'Validation documents',
    'notifications.paymentReminders': 'Rappels paiements',
    'notifications.contractDeadlines': 'Échéances baux',
    'notifications.statusChanges': 'Changements statut',
    'language.select': 'Langue',
    'language.english': 'Anglais',
    'language.french': 'Français',
    'dashboard.total': 'Total',
    'dashboard.monthly': 'Mensuel',
    'dashboard.yearly': 'Annuel',
    'dashboard.thisMonth': 'Ce mois',
    'dashboard.lastMonth': 'Mois dernier',
    'dashboard.thisYear': 'Cette année',
    'dashboard.pending': 'En attente',
    'dashboard.approved': 'Approuvé',
    'dashboard.rejected': 'Rejeté',
    'dashboard.active': 'Actif',
    'dashboard.inactive': 'Inactif',
    'dashboard.vacant': 'Vacant',
    'dashboard.occupied': 'Occupé',
    'dashboard.upToDate': 'À jour',
    'dashboard.overdue': 'En retard',
    'dashboard.paid': 'Payé',
    'dashboard.unpaid': 'Non payé',
    'accounting.recordPayment': 'Enregistrer',
    'accounting.recordCashPayment': 'Paiement espèces',
    'accounting.recordLandlordPayment': 'Nouveau reversement',
    'accounting.addExpense': 'Nouvelle dépense',
    'accounting.editExpense': 'Modifier dépense',
    'accounting.viewExpense': 'Détails dépense',
    'accounting.printExpense': 'Imprimer',
    'accounting.totalRevenue': 'Revenu total',
    'accounting.totalExpenses': 'Dépenses totales',
    'accounting.netIncome': 'Revenu net',
    'accounting.cashBalance': 'Solde disponible',
    'accounting.pendingPayments': 'En attente',
    'accounting.commission': 'Commission',
    'accounting.netAmount': 'Montant net',
    'accounting.paymentMethod': 'Mode',
    'accounting.building': 'Bien',
    'accounting.property': 'Bien',
    'accounting.tenant': 'Locataire',
    'accounting.landlord': 'Propriétaire',
    'accounting.selectTenant': 'Sélectionner locataire',
    'accounting.selectLandlord': 'Sélectionner propriétaire',
    'accounting.selectProperty': 'Sélectionner bien',
    'accounting.selectAccount': 'Sélectionner compte',
    'accounting.paymentDate': 'Date',
    'accounting.rentPeriod': 'Période',
    'accounting.expenseDate': 'Date',
    'accounting.expenseCategory': 'Catégorie',
    'accounting.expenseAmount': 'Montant',
    'accounting.expenseDescription': 'Description',
    'accounting.receiptNumber': 'N° Reçu',
    'accounting.invoiceNumber': 'N° Facture',
    'accounting.recording': 'Enregistrement...',
    'accounting.adding': 'Ajout...',
    'accounting.noCashierAccounts': 'Aucun compte de caisse.',
    'accounting.cashierAccountCreated': 'Compte créé avec succès !',
    'accounting.collections': 'Encaissements',
    'accounting.expenses': 'Dépenses',
    'accounting.collectionsByPeriod': 'Encaissements par période',
    'accounting.cancel': 'Annuler',
    'accounting.addAccount': 'Nouveau compte',
    'accounting.canceledPaymentsHistory': 'Paiements annulés',
    'accounting.amountCanceled': 'Montant annulé',
    'accounting.paymentsByBuilding': 'Paiements par bien',
    'accounting.paymentsByTenant': 'Paiements par locataire',
    'accounting.expensesByPeriod': 'Dépenses par période',
    'accounting.buildingPerformance': 'Performance bien',
    'accounting.paymentStatusBreakdown': 'Statut paiements',
    'accounting.paymentsByPeriod': 'Paiements par période',
    'accounting.commissionsByPeriod': 'Commissions par période',
    'accounting.refundsReport': 'Remboursements',
    'accounting.financialManagement': 'Gestion financière',
    'accounting.quickActions': 'Actions',
    'accounting.viewAllTenants': 'Voir tous les locataires',
    'accounting.recordSecurityDepositPayment': 'Caution',
    'accounting.processSecurityDepositRefund': 'Rembourser caution',
    'accounting.addTransaction': 'Nouvelle transaction',
    'accounting.recentTransactions': 'Transactions récentes',
    'accounting.addCashierAccount': 'Nouveau compte',
    'accounting.recordNewPayment': 'Nouveau paiement',
    'accounting.confirmPaymentApproval': 'Valider paiement',
    'accounting.editExpense': 'Modifier dépense',
    'landlord.myProperties': 'Mes biens',
    'landlord.myTenants': 'Mes locataires',
    'landlord.rentCollected': 'Loyers encaissés',
    'landlord.netPayout': 'Net à percevoir',
    'landlord.paymentHistory': 'Historique',
    'landlord.netPayments': 'Paiements nets',
    'tenant.myRent': 'Loyer',
    'tenant.paymentHistory': 'Historique',
    'tenant.makePayment': 'Payer',
    'tenant.nextPayment': 'Prochain loyer',
    'tenant.leaseAgreement': 'Bail',
    'tenant.documents': 'Documents',
    'sales.listings': 'Annonces',
    'sales.addListing': 'Nouvelle annonce',
    'sales.editListing': 'Modifier annonce',
    'sales.scheduleVisit': 'Planifier visite',
    'sales.visitStatus': 'Statut visite',
    'sales.clientRequests': 'Demandes',
    'technician.workOrders': 'Ordres de travaux',
    'technician.inspections': 'Inspections',
    'technician.maintenance': 'Maintenance',
    'technician.createWorkOrder': 'Nouveau travail',
    'technician.createInspection': 'Nouvelle inspection',
    'admin.clientsPending': 'Clients en attente',
    'admin.documentVerification': 'Vérification documents',
    'admin.debtCollection': 'Recouvrement',
    'admin.automation': 'Automatisation',
    'director.overview': 'Aperçu',
    'director.management': 'Gestion',
    'director.users': 'Utilisateurs',
    'director.properties': 'Biens',
    'director.analytics': 'Analyses',
    'director.subscription': 'Abonnement',
    'actions.add': 'Ajouter',
    'actions.edit': 'Modifier',
    'actions.delete': 'Supprimer',
    'actions.view': 'Voir',
    'actions.save': 'Enregistrer',
    'actions.cancel': 'Annuler',
    'actions.submit': 'Soumettre',
    'actions.approve': 'Approuver',
    'actions.reject': 'Rejeter',
    'actions.print': 'Imprimer',
    'actions.export': 'Exporter',
    'actions.download': 'Télécharger',
    'actions.upload': 'Téléverser',
    'actions.search': 'Rechercher',
    'actions.filter': 'Filtrer',
    'actions.reset': 'Réinitialiser',
    'actions.clear': 'Effacer',
    'actions.close': 'Fermer',
    'actions.back': 'Retour',
    'actions.next': 'Suivant',
    'actions.previous': 'Précédent',
    'actions.send': 'Envoyer',
    'actions.reply': 'Répondre',
    'actions.markAsRead': 'Marquer comme Lu',
    'actions.markAllRead': 'Tout Marquer comme Lu',
    'status.pending': 'En attente',
    'status.approved': 'Approuvé',
    'status.rejected': 'Rejeté',
    'status.active': 'Actif',
    'status.inactive': 'Inactif',
    'status.vacant': 'Vacant',
    'status.occupied': 'Occupé',
    'status.paid': 'Payé',
    'status.unpaid': 'Non payé',
    'status.overdue': 'En retard',
    'status.completed': 'Terminé',
    'status.inProgress': 'En cours',
    'status.cancelled': 'Annulé',
    'messages.sendMessage': 'Envoyer un Message',
    'messages.typeMessage': 'Tapez un message...',
    'messages.noMessages': 'Aucun message',
    'messages.noConversations': 'Aucune conversation',
    'messages.selectUser': 'Sélectionnez un utilisateur pour commencer à discuter',
    'reports.generate': 'Générer un Rapport',
    'reports.download': 'Télécharger le Rapport',
    'reports.export': 'Exporter le Rapport',
    'reports.selectType': 'Sélectionner le Type de Rapport',
    'reports.selectPeriod': 'Sélectionner la Période',
    'reports.startDate': 'Date de Début',
    'reports.endDate': 'Date de Fin',
    'modal.confirm': 'Confirmer',
    'modal.cancel': 'Annuler',
    'modal.deleteConfirm': 'Êtes-vous sûr de vouloir supprimer cet élément?',
    'modal.unsavedChanges': 'Vous avez des modifications non enregistrées. Êtes-vous sûr de vouloir partir?',
    'error.required': 'Ce champ est requis',
    'error.invalidEmail': 'Adresse e-mail invalide',
    'error.invalidPhone': 'Numéro de téléphone invalide',
    'error.invalidAmount': 'Montant invalide',
    'error.uploadFailed': 'Échec du téléversement',
    'error.loadFailed': 'Échec du chargement des données',
    'error.saveFailed': 'Échec de l\'enregistrement',
    'error.deleteFailed': 'Échec de la suppression',
    'error.networkError': 'Erreur réseau. Veuillez réessayer.',
    'error.unauthorized': 'Accès non autorisé',
    'error.notFound': 'Non trouvé',
    'error.serverError': 'Erreur serveur. Veuillez réessayer plus tard.',
    'success.saved': 'Enregistré avec succès',
    'success.deleted': 'Supprimé avec succès',
    'success.uploaded': 'Téléversé avec succès',
    'success.sent': 'Envoyé avec succès',
    'success.updated': 'Mis à jour avec succès',
    'success.created': 'Créé avec succès'
  }
};
export const getLanguage = () => {
  return localStorage.getItem('language') || 'fr';
};
export const setLanguage = (lang) => {
  localStorage.setItem('language', lang);
  window.dispatchEvent(new CustomEvent('languageChange', { detail: lang }));
};
export const t = (key, lang = null) => {
  const currentLang = lang || getLanguage();
  const langTranslations = translations[currentLang] || translations['en'];
  if (langTranslations && langTranslations[key]) {
    return langTranslations[key];
  }
  const keys = key.split('.');
  let value = langTranslations;

  for (const k of keys) {
    if (value && typeof value === 'object') {
      value = value[k];
    } else {
      return key;
    }
  }

  return value || key;
};
// Plateforme destinée à la Côte d'Ivoire : français par défaut, l'anglais reste disponible dans le sélecteur
if (!localStorage.getItem('language')) {
  setLanguage('fr');
}

export default { getLanguage, setLanguage, t, translations };
